/* src/pages/HomePage.module.css */
.main { padding-top: var(--nav-height); }

/* ─── HERO ─── */
.hero {
  min-height: 100vh; display: flex; align-items: center;
  position: relative; overflow: hidden;
  padding: calc(var(--nav-height) + 1.5rem) 0 3rem;
}
.heroBg {
  position: absolute; inset: 0;
  background:
    linear-gradient(180deg, rgba(2,14,24,0.78), rgba(2,14,24,0.96)),
    url('/HERO.png') center/cover no-repeat,
    radial-gradient(ellipse 70% 80% at 75% 40%, rgba(26,127,193,0.18) 0%, transparent 65%),
    radial-gradient(ellipse 50% 50% at 20% 75%, rgba(61,187,47,0.1) 0%, transparent 60%);
  filter: saturate(1.05);
}
.heroGrid {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(59,168,232,0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(59,168,232,0.035) 1px, transparent 1px);
  background-size: 72px 72px;
  mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 0%, transparent 100%);
}
.heroOrb {
  position: absolute; right: -100px; top: 50%; transform: translateY(-50%);
  width: 600px; height: 600px; border-radius: 50%;
  background: radial-gradient(circle, rgba(26,127,193,0.07) 0%, transparent 70%);
  pointer-events: none;
}
.heroContent { position: relative; z-index: 2; max-width: 780px; }
.heroEyebrow { margin-bottom: 0.75rem; }
.heroGreeting {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.4rem;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.14);
  background: rgba(255,255,255,0.05);
  color: #d6eeff;
  font-size: 13px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  opacity: 0;
  transform: translateY(-14px);
  animation: greetingFloat 0.9s ease forwards;
  box-shadow: 0 24px 80px rgba(0,0,0,0.18);
}
.greetingEmoji {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(61,187,47,0.14);
  color: #ffffff;
}
.heroH1 {
  font-family: 'Syne', sans-serif; font-weight: 800;
  font-size: clamp(42px, 7vw, 96px);
  line-height: 0.95; margin-bottom: 1.5rem;
}
.heroEm { font-style: normal; color: var(--blue-light); }
.heroSub { font-size: 19px; max-width: 560px; margin-bottom: 2.5rem; line-height: 1.7; }
.heroActions { display: flex; gap: 1rem; flex-wrap: wrap; align-items: center; margin-bottom: 3.5rem; }
.heroProof { display: flex; align-items: center; gap: 1.5rem; flex-wrap: wrap; }
.proofItem { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--muted); }
.proofDot { width: 6px; height: 6px; border-radius: 50%; background: var(--green); flex-shrink: 0; }
.heroScrollPrompt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 1rem;
  border-radius: 999px;
  background: rgba(255,255,255,0.12);
  border: 1px solid rgba(255,255,255,0.18);
  color: rgba(255,255,255,0.95);
  font-size: 13px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  animation: greetingFloat 0.9s ease forwards;
}
.scrollButton {
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.scrollArrow {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(61,187,47,0.16);
  border: 1px solid rgba(255,255,255,0.14);
  color: #ffffff;
  font-size: 20px;
  animation: floatArrow 1.4s ease-in-out infinite;
}
.heroVisual { margin-top: 2.5rem; display: flex; justify-content: center; width: 100%; }
.heroCard {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 28px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  box-shadow: 0 40px 100px rgba(0,0,0,0.22);
}
.heroCardImg {
  width: 100%;
  height: clamp(300px, 55vh, 360px);
  object-fit: cover;
  display: block;
}
.heroCardCTA {
  position: absolute;
  left: 1.5rem;
  bottom: 1.5rem;
  z-index: 2;
  max-width: 380px;
  background: rgba(5, 14, 24, 0.82);
  padding: 1.35rem 1.5rem;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.1);
  animation: heroCtaPop 0.9s ease forwards;
}
.heroCardCTA h3 {
  font-size: clamp(20px, 2.4vw, 26px);
  line-height: 1.2;
  margin: 1rem 0 0.5rem;
  color: #ffffff;
}
.heroCardCTA p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255,255,255,0.84);
}
.heroCardActions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}
.btn-hero { margin-top: 0; }
@keyframes greetingFloat {
  from { opacity: 0; transform: translateY(-12px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes floatArrow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}
@keyframes heroCtaPop {
  0% { opacity: 0; transform: translateY(24px) scale(0.95); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
}

/* ─── MARQUEE ─── */
.marqueeWrap {
  overflow: hidden; background: var(--dark2);
  border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
  padding: 18px 0;
}
.marqueeInner {
  display: flex; gap: 3rem; width: max-content;
  animation: marquee 30s linear infinite;
}
.marqueeInner:hover { animation-play-state: paused; }
@keyframes marquee { from{transform:translateX(0)} to{transform:translateX(-50%)} }
.marqueeItem {
  display: flex; align-items: center; gap: 1rem;
  font-size: 13px; font-weight: 600; letter-spacing: 1px;
  text-transform: uppercase; color: var(--muted); white-space: nowrap;
}
.marqueeSep { color: var(--green); font-size: 18px; margin-left: 1rem; }

/* ─── SERVICES ─── */
.serviceStrip { display: grid; grid-template-columns: repeat(3,1fr); gap: 1.5rem; }
.serviceCard {
  background: var(--card); border: 1px solid var(--border);
  border-radius: var(--radius-lg); overflow: hidden;
  transition: transform var(--transition), border-color var(--transition);
  display: flex; flex-direction: column; height: 100%;
}
.serviceCard:hover { transform: translateY(-5px); border-color: var(--border-strong); }
.serviceCardTop { padding: 2.5rem 2rem 2rem; flex: 1; }
.serviceIcon { font-size: 40px; margin-bottom: 1.2rem; }
.serviceCardTop h3 { font-size: 22px; color: var(--text); margin-bottom: 0.75rem; }
.serviceCardTop p { font-size: 14px; line-height: 1.6; }
.serviceCardBottom {
  padding: 1.2rem 2rem; border-top: 1px solid var(--border);
  display: flex; align-items: center; justify-content: space-between; gap: 1rem;
}
.serviceTag {
  font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
  color: var(--green); background: var(--green-pale);
  border: 1px solid rgba(61,187,47,0.2); padding: 4px 12px; border-radius: 4px;
}
.serviceLink { color: var(--blue-light); font-size: 13px; font-weight: 600; }
.serviceLink:hover { text-decoration: underline; }

/* ─── HOW IT WORKS ─── */
.howSection {
  padding: 100px 0;
  background: var(--dark2); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
}
.stepsGrid {
  display: grid; grid-template-columns: repeat(4,1fr);
  gap: 1.5px; background: var(--border);
  border: 1px solid var(--border); border-radius: var(--radius-lg);
  overflow: hidden; margin-top: 3rem;
}
.stepCard {
  background: var(--card); padding: 2.5rem 2rem;
  position: relative; overflow: hidden;
  transition: background var(--transition);
}
.stepCard:hover { background: var(--card2); }
.stepNum {
  font-family: 'Bebas Neue', sans-serif; font-size: 80px;
  line-height: 1; color: rgba(63,168,232,0.06);
  position: absolute; top: 1rem; right: 1.5rem; user-select: none;
}
.stepIcon { font-size: 32px; margin-bottom: 1.2rem; }

/* ─── VIDEO ─── */
.videoSection {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  padding: 100px 0;
  background: var(--dark2);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  overflow: hidden;
}
.videoLayout {
  display: grid; grid-template-columns: 1fr 1.4fr;
  gap: 5rem; align-items: center;
}
.videoBox {
  position: relative; width: 100%; min-height: 420px;
  border-radius: var(--radius-lg);
  background: var(--dark3); border: 1px solid var(--border);
  overflow: hidden;
}
.videoPlayer {
  width: 100%;
  height: 100%;
  min-height: 420px;
  object-fit: cover;
  display: block;
}
.videoTag {
  position: absolute; top: 14px; left: 14px; z-index: 2;
  background: rgba(6,10,15,0.85); backdrop-filter: blur(8px);
  border: 1px solid var(--border-strong); border-radius: 6px;
  padding: 4px 12px; font-size: 11px; font-weight: 700;
  letter-spacing: 1px; text-transform: uppercase; color: var(--blue-light);
}
.videoPlaceholder {
  aspect-ratio: 16/9; display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 1rem;
  background: radial-gradient(ellipse 60% 60% at 50% 50%, rgba(26,127,193,0.07) 0%, transparent 70%);
}
.playBtn {
  width: 72px; height: 72px; border-radius: 50%;
  border: 2px solid rgba(63,168,232,0.5);
  display: flex; align-items: center; justify-content: center;
  font-size: 28px; color: var(--blue-light);
  transition: var(--transition); cursor: pointer;
}
.playBtn:hover { background: rgba(63,168,232,0.12); border-color: var(--blue-light); transform: scale(1.08); }

/* ─── TESTIMONIALS ─── */
.testiSection {
  padding: 100px 0;
  background: var(--dark2); border-top: 1px solid var(--border); border-bottom: 1px solid var(--border);
}
.testiCard {
  background: var(--card); border: 1px solid var(--border);
  border-radius: var(--radius-lg); padding: 2rem;
}
.testiStars { color: #f5a623; font-size: 14px; margin-bottom: 1rem; }
.testiText { font-size: 15px; font-style: italic; color: var(--muted); line-height: 1.7; margin-bottom: 1.5rem; }
.testiAuthor { display: flex; align-items: center; gap: 12px; }
.testiAvatar {
  width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
  background: linear-gradient(135deg, var(--blue), var(--green-dark));
  display: flex; align-items: center; justify-content: center;
  font-family: 'Syne', sans-serif; font-size: 14px; font-weight: 700; color: #fff;
}
.authorName { font-size: 14px; font-weight: 600; color: var(--text); }
.authorBiz { font-size: 12px; color: var(--muted); }

/* ─── FAQ ─── */
.faqSection {
  padding: 100px 0;
  background: var(--dark2); border-top: 1px solid var(--border);
}
.faqList { display: flex; flex-direction: column; }
.faqItem { border-bottom: 1px solid var(--border); }
.faqQ {
  width: 100%; background: none; border: none; text-align: left;
  padding: 1.5rem 0; cursor: pointer;
  display: flex; align-items: center; justify-content: space-between; gap: 1rem;
  font-family: 'Syne', sans-serif; font-size: 17px; font-weight: 700;
  color: var(--text); transition: color var(--transition);
}
.faqQ:hover { color: var(--blue-light); }
.faqIcon {
  width: 28px; height: 28px; border-radius: 50%; flex-shrink: 0;
  border: 1px solid var(--border-strong);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; color: var(--blue-light);
  transition: transform var(--transition);
}
.faqIconOpen { transform: rotate(45deg); }
.faqA { overflow: hidden; max-height: 0; transition: max-height 0.35s ease; }
.faqAOpen { max-height: 400px; }
.faqA p { font-size: 15px; line-height: 1.7; padding-bottom: 1.5rem; max-width: 700px; }

@media (max-width: 900px) {
  .serviceStrip, .stepsGrid { grid-template-columns: 1fr; }
  .videoLayout { grid-template-columns: 1fr; gap: 2.5rem; }
}
